<template>
  <div>
    <b-container
      class="text-right navber-top-bar pt-2 px-sm-0 d-md-block d-none"
    >
      <!-- <b-link href="#foo" class="link-item px-2"
        ><b-icon icon="arrow-up"></b-icon>最新消息</b-link
      > -->
      <router-link :to="{ name: '廠商介紹' }" v-slot="{ href }">
        <a :href="href" class="link-item">
          <b-icon icon="shop"></b-icon>
          廠商介紹
        </a>
      </router-link>
      <router-link :to="{ name: '購物須知' }" v-slot="{ href }">
        <a :href="href" class="link-item ml-2">
          <b-icon icon="exclamation-circle"></b-icon>
          購物須知
        </a>
      </router-link>
      <router-link :to="{ name: '訂單查詢' }" v-slot="{ href }">
        <a :href="href" class="link-item ml-2">
          <b-icon icon="file-text"></b-icon>
          訂單查詢
        </a>
      </router-link>
    </b-container>
    <b-navbar type="light" class="pt-sm-0">
      <b-container>
        <b-navbar-brand href="/">
          <img
            src="@/assets/image/quartercar-logo-small-red.svg"
            class="d-inline-block align-center"
            alt="logo"
            id="logoImage"
          />
        </b-navbar-brand>
        <b-collapse id="nav-collapse" is-nav>
          <form @submit.stop.prevent="searchSubmit" class="ml-auto">
            <b-input-group class="justify-content-center d-none d-md-flex">
              <b-form-input
                type="text"
                class="rounded-0"
                v-model="search"
                placeholder="搜尋零件名稱"
                style="width: 400px"
              >
              </b-form-input>
              <b-input-group-append>
                <b-button
                  block
                  squared
                  type="submit"
                  variant="platform_main"
                  class="text-white px-3"
                >
                  <b-icon icon="search" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </form>
          <b-navbar-nav class="ml-auto">
            <li class="nav-item">
              <b-button
                v-b-toggle.notifySidebar
                variant="link"
                class="nav-link"
              >
                <b-iconstack>
                  <b-icon
                    stacked
                    icon="bell-fill"
                    variant="platform_main"
                    scale="0.8"
                  ></b-icon>
                  <b-icon
                    v-if="has_notify"
                    stacked
                    icon="dot"
                    variant="danger"
                    shift-h="4"
                    shift-v="4"
                    scale="2"
                  ></b-icon>
                </b-iconstack>
              </b-button>
            </li>
            <b-nav-item-dropdown
              right
              no-caret
              class="d-md-inline-block d-none"
            >
              <template v-slot:button-content>
                <b-icon icon="person-fill" variant="platform_main"></b-icon>
              </template>
              <b-dropdown-item href="/User">會員資料</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item href="#" @click="signOut">登出</b-dropdown-item>
            </b-nav-item-dropdown>
            <li class="nav-item" v-if="shopping_car_qty">
              <router-link :to="{ name: '購物車' }" v-slot="{ href }">
                <a :href="href" class="nav-link position-relative">
                  <b-icon icon="cart-fill" variant="platform_main"></b-icon>
                  <span class="shopping-car-qty">{{ shopping_car_qty }}</span>
                </a>
              </router-link>
            </li>
            <b-nav-item-dropdown right no-caret v-else>
              <template v-slot:button-content>
                <b-icon icon="cart-fill" variant="platform_main"></b-icon>
              </template>
              <b-dropdown-item>您的購物車無商品</b-dropdown-item>
            </b-nav-item-dropdown>
            <li class="nav-item collapsed d-md-none d-inline-block">
              <b-button v-b-toggle.menuSidebar variant="link" class="nav-link">
                <b-icon icon="list" variant="platform_main"></b-icon>
              </b-button>
            </li>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
    <!-- <b-modal id="modal-search" hide-footer hide-header>
      <form @submit.stop.prevent="searchSubmit">
        <b-input-group class="justify-content-center">
          <b-form-input
            type="text"
            class="rounded-0"
            v-model="search"
            placeholder="搜尋零件名稱"
            autofocus
          >
          </b-form-input>
          <b-input-group-append>
            <b-button
              block
              squared
              type="submit"
              variant="platform_main"
              class="text-white px-3"
            >
              <b-icon icon="search" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </form>
    </b-modal> -->
    <b-sidebar
      id="menuSidebar"
      shadow
      z-index="99"
      right
      backdrop
      title="MENU"
      class="sidebar"
      header-class="flex-row-reverse border-bottom"
    >
      <nav>
        <ul class="nav flex-column pt-2">
          <li class="nav-item">
            <router-link :to="{ name: '會員資料' }" v-slot="{ href, isActive }">
              <a
                class="nav-link py-2"
                :class="{ active: isActive }"
                :href="href"
                >會員資料</a
              >
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: '訂單查詢' }" v-slot="{ href, isActive }">
              <a
                class="nav-link py-2"
                :class="{ active: isActive }"
                :href="href"
                >訂單查詢</a
              >
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: '購物須知' }" v-slot="{ href, isActive }">
              <a
                class="nav-link py-2"
                :class="{ active: isActive }"
                :href="href"
                >購物須知</a
              >
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: '廠商介紹' }" v-slot="{ href, isActive }">
              <a
                class="nav-link py-2"
                :class="{ active: isActive }"
                :href="href"
                >廠商介紹</a
              >
            </router-link>
          </li>
        </ul>
      </nav>
      <template v-slot:footer>
        <b-button block squared @click="signOut" variant="platform_main"
          >登出</b-button
        >
      </template>
    </b-sidebar>
    <b-sidebar
      id="notifySidebar"
      shadow
      z-index="1000"
      right
      backdrop
      title="通知中心"
      class="sidebar notify"
      header-class="flex-row-reverse border-bottom"
      v-if="notify_list"
    >
      <div class="p-3 border-bottom">
        <small class="mr-2">推播授權狀態：</small>
        <small class="d-inline-block">{{ notificationStatus }}</small>
      </div>
      <nav v-if="notify_list.length">
        <ul class="nav flex-column">
          <li
            class="nav-item border-bottom"
            v-for="item in notify_list"
            :key="item.uuid"
          >
            <a
              class="nav-link py-2"
              :class="{ read: !item.not_read }"
              href="#"
              @click.prevent="isRead(item.uuid, item.message)"
            >
              <div class="notify-time">
                {{ format(item.created_at, "yyyy-MM-dd hh:mm") }}
              </div>
              <div class="notify-message">{{ item.message }}</div>
            </a>
          </li>
        </ul>
      </nav>
      <div v-else class="p-3">目前尚無通知</div>
      <template #footer>
        <div class="text-center p-2" v-if="notify_list.length">
          <b-button
            variant="platform_main"
            squared
            type="button"
            @click="allRead"
            ><b-icon icon="check2" class="mr-2"></b-icon>全部標示已讀</b-button
          >
        </div>
      </template>
    </b-sidebar>
    <b-toast
      id="notify-toast"
      title="通知中心"
      toaster="b-toaster-top-center"
      solid
      :appendToast="false"
      variant="platform_main"
    >
      <a v-b-toggle href="#notifySidebar" @click.prevent>
        您有{{ has_notify }}筆新的通知，點擊我開啟列表
      </a>
    </b-toast>
  </div>
</template>

<style lang="scss" scoped>
.navber-top-bar {
  .link-item {
    color: #333;
    font-size: 14px;
  }
}
.shopping-car-qty {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  color: $platform_main;
  z-index: 1;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 20px;
    border: 1px solid $platform_main;
    z-index: -1;
  }
}
.sidebar {
  ::v-deep .close {
    margin-left: auto;
    margin-right: 0 !important;
  }
  ::v-deep header {
    font-size: 20px;
  }
  ::v-deep .b-sidebar-footer {
    a {
      color: #fff;
    }
  }
}
.notify {
  ::v-deep .close {
    margin-left: auto;
    margin-right: 0 !important;
  }
  ::v-deep header {
    font-size: 20px;
  }
  ::v-deep .nav-link {
    background-color: #fff0f0;
    &.read {
      background-color: #fff;
    }
  }
  &-time {
    font-size: 12px;
    color: #888;
  }
  &-message {
    font-size: 14px;
    color: #333;
    font-weight: initial;
  }
}
#notify-toast {
  a {
    color: #551518;
  }
}
</style>

<script>
import { ShoppingCar, Notify } from "@/assets/api/platform.js";
import { Toast } from "@/plugins/sweetalert2.js";
import "@/assets/js/dateFormat.js";

export default {
  name: "Navbar",
  props: ["token", "transferShoppingCarQty"],
  data() {
    return {
      has_notify: null,
      notify_list: null,
      user: null,
      search: "",
      shopping_car: null,
      shopping_car_qty: 0,
      notificationStatus: ""
    };
  },
  created() {
    this.getShoppingCarData();
    this.shopping_car_qty = this.transferShoppingCarQty;

    Notify.get(this.token)
      .then(res => {
        if (res.status == 200) {
          this.has_notify = res.data.count;
          this.notify_list = res.data.data.data.reverse();
        } else {
          Toast.fire({
            icon: "error",
            title: "無法取得通知訊息",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  watch: {
    transferShoppingCarQty(val) {
      this.shopping_car_qty = val;
    },
    has_notify(val) {
      if (val && !this.isMobile) {
        this.$bvToast.show("notify-toast");
      }
    }
  },
  methods: {
    format(date, formatText) {
      // "yyyy-MM-dd"
      return new Date(date).format(formatText);
    },
    signOut() {
      localStorage.removeItem("platform-api_token");
      this.$router.push({ name: "會員登入" });
    },
    getShoppingCarData() {
      ShoppingCar.get(this.token)
        .then(res => {
          if (res.status <= 201) {
            this.shopping_car = res.data;
            let newQty = 0;
            Object.keys(this.shopping_car).forEach(key => {
              newQty = newQty + this.shopping_car[key].items.length;
            });
            this.shopping_car_qty = newQty;
          } else {
            Toast.fire({
              icon: "error",
              title: "購物車資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    searchSubmit() {
      this.$emit("searchKeyword", this.search);
      if (this.$route.name != "首頁") {
        this.$router.push("/");
      } else {
        this.search = "";
      }
    },
    getOrderNum(text) {
      const slice = text.indexOf(": ", 0);
      return text.slice(slice + 2, -1);
    },
    isRead(uuid, message) {
      Notify.read(uuid, this.token).then(() => {
        Notify.get(this.token).then(data => {
          this.has_notify = data.data.count;
          this.notify_list = data.data.data.data;
        });
        this.$router.push({
          name: "訂單查詢",
          query: { search: this.getOrderNum(message) }
        });
      });
    },
    allRead() {
      this.notify_list.forEach(item => {
        if (!item.not_read) return;
        Notify.read(item.uuid, this.token);
      });
      this.$root.$emit("bv::toggle::collapse", "notifySidebar");
      setTimeout(() => {
        Notify.get(this.token).then(data => {
          this.has_notify = data.data.count;
          this.notify_list = data.data.data.data;
        });
      }, 500);
    },
    registeFCM() {
      this.$messaging
        .requestPermission()
        .then(() => {
          // 先判斷cookies有沒有token，沒有再取token
          var ckv =
            document.cookie.replace(
              /(?:(?:^|.*;\\s*)augustusWsPush\s*=\s*([^;]*).*$)|^.*$/,
              "$1"
            ) || null;
          if (ckv === null) {
            // 拿到token，firebase-messaging-sw.js 就會存 Service Workers 裡

            this.$messaging.getToken().then(currentToken => {
              Notify.saveToken(
                {
                  token: currentToken
                },
                this.token
              ).then(res => {
                console.log(res);
              });

              // token存至firebase
              // var id = currentToken.split(":")[0];
              // this.$database
              //   .ref("pushUsers/" + id)
              //   .set({ token: currentToken });

              // token存至cookies
              document.cookie = "augustusWsPush=" + currentToken;
            });
          }
          // cookies 已存在，從 cookies 取出後傳至 firebase
          else {
            // var id = ckv.split(":")[0];
            // this.$database.ref("pushUsers/" + id).set({ token: ckv });
            Notify.saveToken(
              {
                token: ckv
              },
              this.token
            ).then(res => {
              console.log(res);
            });
          }
          console.log("Notification permission granted.");
          this.notificationPermission();
        })
        .catch(err => {
          this.notificationPermission();
          console.log("Unable to get permission to notify.", err);
        });
    },
    notificationPermission() {
      if (!Notification) return;
      switch (Notification.permission) {
        case "default":
          this.notificationStatus = "尚未給予任何權限，您將不會收到推播消息";
          break;
        case "granted":
          this.notificationStatus = "允許通知";
          break;
        case "denied":
          this.notificationStatus = "拒絕通知，您將不會收到推播消息";
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    this.registeFCM();
    this.$messaging.onMessage(payload => {
      const notification = payload.notification || payload.data;
      const noteTitle = notification.title;
      const noteOptions = {
        body: notification.body,
        icon: "/favicon-96.png",
        badge: "/favicon-96.png"
      };
      new Notification(noteTitle, noteOptions);
      Notification.onclick = function(event) {
        event.preventDefault();
        window.open("/order", "_blank");
      };
    });
  }
};
</script>
